import {useTranslation} from "react-i18next";

import i18n from "../../i18n";
import FunctionButton from "../../utilities/Buttons/FunctionButton";
import {UI_PERMISSION_TYPE} from "../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

const TranslationButton = () => {
  const {t} = useTranslation();

  const changeLanguage = language => {
    i18n.changeLanguage(language, err => {
      if (err) return;
    });
  };

  return (
    <div className="flex_container jcc fd w100" style={{margin: "15px"}}>
      {t("Translate into")}
      <div style={{margin: "15px"}}>
        <FunctionButton
          style={{margin: "15px"}}
          name={t("English")}
          onClick={() => changeLanguage("en")}
          uiPermissionType={UI_PERMISSION_TYPE.READABLE}
        />

        <FunctionButton
          name={t("Ukrainian")}
          onClick={() => changeLanguage("uk")}
          uiPermissionType={UI_PERMISSION_TYPE.READABLE}
        />
      </div>
    </div>
  );
};

export default TranslationButton;
